/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { forwardRef, PropsWithChildren } from "react";
import DropSelect from "components-new/DropSelect";
import sass from "./nav.module.sass";
import { ReactComponent as RemoveIcon } from "images/TrashCan.svg";

interface IDropInterface extends PropsWithChildren {
	target?: HTMLOrSVGElement;
	click: () => void;
	clear?: boolean;
	addClass?: boolean;
}

const DropMenu = forwardRef<any, IDropInterface>(({ target, addClass = true, clear = false, click, children }, ref) => {
	return target ? (
		<DropSelect target={target as HTMLElement}>
			<div ref={ref}>
				{children ? (
					Array.isArray(children) ? (
						children.map((child, index) => (
							<div key={index} className={sass.remove}>
								{child}
							</div>
						))
					) : addClass ? (
						<div className={sass.remove}>{children}</div>
					) : (
						children
					)
				) : null}
				{!clear && (
					<div onClick={click} className={sass.remove}>
						<RemoveIcon />
						Удалить
					</div>
				)}
			</div>
		</DropSelect>
	) : null;
});

export default DropMenu;
